var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.url,"target":"_blank","rel":"noopener"}},[_c('font-awesome-icon',{attrs:{"icon":[_vm.isBrand ? 'fab' : 'fas', _vm.icon],"size":"10x"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }